import { useNotificationSettings } from "../hooks/use-notification-settings";
import { ToggleRow } from "./SettingsUIComponents";
import { notificationsSupported } from "../../../shared/hooks/use-notifications";
import { isNative } from "../../../lib/capacitor";

interface NotificationsSectionProps {
  readonly permissionGranted: boolean;
  readonly onRequestPermission: () => void;
}

export function NotificationsSection({
  permissionGranted,
  onRequestPermission,
}: NotificationsSectionProps) {
  const { settings, update } = useNotificationSettings();
  const notSupported = !notificationsSupported;
  const denied = !notSupported && !isNative && !permissionGranted
    && "Notification" in window && Notification.permission === "denied";

  return (
    <div className="flex flex-col gap-4">
      {notSupported && (
        <p className="text-xs text-ink-muted">
          Les notifications ne sont pas supportées sur cet appareil.
        </p>
      )}

      {denied && (
        <div className="px-3 py-2 rounded-lg bg-red-500/10 text-xs text-red-400">
          Les notifications sont bloquées. Autorisez-les dans les paramètres de votre navigateur.
        </div>
      )}

      {!notSupported && !permissionGranted && !denied && (
        <button
          type="button"
          onClick={onRequestPermission}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-medium rounded-md bg-accent text-white hover:bg-accent/90 transition-colors w-fit"
        >
          Autoriser les notifications
        </button>
      )}

      <ToggleRow
        label="Événements"
        description="Rappels avant vos événements"
        checked={settings.eventNotifications}
        onChange={() => update({ eventNotifications: !settings.eventNotifications })}
      />

      <ToggleRow
        label="Tâches"
        description="Rappels pour les tâches avec échéance"
        checked={settings.taskNotifications}
        onChange={() => update({ taskNotifications: !settings.taskNotifications })}
      />

      <ToggleRow
        label="Minuteurs"
        description="Notification en fin de session"
        checked={settings.timerNotifications}
        onChange={() => update({ timerNotifications: !settings.timerNotifications })}
      />
    </div>
  );
}
